import { default as domainLearningPath } from './store/index'

export default {
    domainLearningPath
}
